import { render, staticRenderFns } from "./BaseStatictics.vue?vue&type=template&id=a6f957b0&scoped=true&"
import script from "./BaseStatictics.vue?vue&type=script&lang=js&"
export * from "./BaseStatictics.vue?vue&type=script&lang=js&"
import style0 from "./BaseStatictics.vue?vue&type=style&index=0&id=a6f957b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f957b0",
  null
  
)

export default component.exports